module.exports = __webpack_public_path__ + "static/media/woo7.64c5cff5.png";